



































import { getModule } from "vuex-module-decorators";
import { Component, Vue } from "vue-property-decorator";
import HelloWorld from "@/components/HelloWorld.vue";

import ConnectionStore from "@/store/ConnectionStore";
import ConnectionGroup from "@/data/ConnectionGroup";

@Component
export default class App extends Vue {

    protected store:ConnectionStore = getModule(ConnectionStore, this.$store);

    protected created(){ 
        // this.store.loadFilesFromServer( this.$route.query );
    }

    protected mounted(){
        if ( Object.keys(this.$route.query).length > 0 ){
            this.store.loadFilesFromServer( this.$route.query );
        }
    }
}
